import { getProjectList} from '@/api/DataNotes'
const datanotes = {
    namespaced: true,
    state: {
        folders: {
            foldersList: [],
            cIndex: 0
        },
        title: '项目列表',
        type: 0,
        authority: 0,
        fileMark: '',//文件标识，用于返回反选
        pageFrom: '' // 页面类型
    },
    getters: {
        folders: (state) => {
            return state.folders
        },
        cFolder: (state) => {
            return state.folders.foldersList[state.folders.cIndex]
        },
        cFolders: (state) => {
            return state.folders.foldersList.slice(0, state.folders.cIndex + 1)
        },
        path: (state, index) => {
            let cFolders = state.folders.foldersList.slice(1, state.folders.cIndex + 1)
            let path = '/'
            cFolders.forEach((folder) => {
                if (folder.type == 0) {
                    path += folder.path + '/'
                }
            })
            return path
        },
        authority: (state) => {
            return state.authority
        },
        title: (state) => {
            return state.title
        },
        type: (state) => {
            return state.type
        },
        fileMark: (state) => {
            return state.fileMark
        }
    },
    mutations: {
        initStore (state) {
            state.folders = {
                foldersList: [],
                cIndex: 0,
            },
                state.title = '项目列表',
                state.type = 0
            sessionStorage.setItem('datanotes', JSON.stringify(state))
        },
        restore (state) {
            let oState = JSON.parse(sessionStorage.getItem('datanotes'))
            if (oState) {
                state.folders = oState.folders
                state.title = oState.title
                state.type = oState.type
                state.authority = oState.authority
            }
        },
        pushFolder (state, folder) {
            state.folders.foldersList.splice(state.folders.cIndex + 1)
            state.folders.foldersList.push(folder);
            state.folders.cIndex = state.folders.foldersList.length - 1
            sessionStorage.setItem('datanotes', JSON.stringify(state))
        },
        changeCurrent (state, folder) {
            let index = state.folders.foldersList.indexOf(folder);
            state.folders.cIndex = index
            sessionStorage.setItem('datanotes', JSON.stringify(state))
        },
        changeTitle (state, title) {
            state.title = title
            sessionStorage.setItem('datanotes', JSON.stringify(state))
        },
        changeType (state, type) {
            state.type = type
            sessionStorage.setItem('datanotes', JSON.stringify(state))
        },
        changeAuthority (state, authority) {
            state.authority = authority
            sessionStorage.setItem('datanotes', JSON.stringify(state))
        },
        changeFileMark (state, fileMark) {
            state.fileMark = fileMark
            sessionStorage.setItem('datanotes', JSON.stringify(state))
        },
        setPageFrom(state, pageFrom) {
          state.pageFrom = pageFrom
        }
    },
    actions: {
        routeChange ({ state, getters }, path) {
            let cPath = path + '/'
            for (let i = 0; i < state.folders.foldersList.length; i++) {
                state.folders.cIndex = i
                if (getters.path == cPath) {
                    return
                }
            }

            // let paths = path.split('/')
            // let cPath = paths.pop()
            // state.folders.foldersList.forEach((folder, index)=>{
            //     if(folder.path == cPath || (cPath == "" && index == 0)){
            //         state.folders.cIndex = index
            //     }
            // })
        },

        async initFolders({ commit }, { pid, type }) {
            if(!pid) return
            const data = await getProjectList(pid, null, 1, 1)
            if(data.rows && data.rows[0]) {
              if (data.rows[0]) {
                commit('initStore')
                commit('pushFolder', data.rows[0])
                commit('changeTitle', data.rows[0].title)
                commit('changeType', type || 0)
                commit('changeAuthority', data.rows[0].authority)
              }
            }
        }
    }
}

export default datanotes



// WEBPACK FOOTER //
// ./src/store/modules/datanotes.js